import React, { useEffect, useState } from "react"
import { Col, Row, Table, Form, Container } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import {
  dateFormat,
  numberFormat,
  refreshPage,
} from "../../../../Helpers/Utils/Common"
import cleanLogo from "../../../../Assets/Images/Login/transparent_bg.png"
import signature from "../../../../Assets/Images/signature.png"
import Navbar from "../../../../Components/Navbar/Navbar"
import POModal from "./../../PurchaseOrders/Components/POModal"
import PaymentTable from "../../../Sales/PaymentTable"
import { getPurchaseRequest } from "../../../../Helpers/apiCalls/Purchases/purchaseRequestApi"
import Footer from "../../../../Components/Footer/Footer"

export default function PrintPurchaseRequest() {
  const { id } = useParams()
  const poID = id
  let navigate = useNavigate()
  const [inactive, setInactive] = useState(true)
  const [printPO, setPrintPO] = useState([])
  const [items, setItems] = useState([])
  const [note, setNote] = useState("")
  const [paymentInfo, setPaymentInfo] = useState([])
  const [isClicked, setIsClicked] = useState(false)

  const [showSendModal, setShowSendModal] = useState(false)
  const handleShowSendModal = () => setShowSendModal(true)
  const handleCloseSendModal = () => setShowSendModal(false)

  async function fetchPurchaseRequest() {
    setItems([])
    setPrintPO([])
    const response = await getPurchaseRequest({ id: id })
    if (response.data) {
      var data = response.data.data.map((data) => {
        var info = data
        info.has_attachment =
          data.purchase_request_attachments?.length > 0 ? true : false
        return info
      })
      setPrintPO(data[0])

      // let remarksdata = [];
      // for(let i = 0; i < data[0].purchase_request_remarks.length; i++) {
      //     remarksdata.push({
      //         details: data[0].purchase_request_remarks[i].details,
      //         added_by_name: data[0].purchase_request_remarks[i].added_by_name
      //     })
      // }

      // setNotes(remarksdata);

      var itemsdata = data[0].purchase_request_items.map((data) => {
        var info = data
        info.item_id_value = {
          label: data.item_name,
          value: data.item_id,
        }
        return info
      })

      // setFileList(response.data.data[0].purchase_request_attachments);
      setItems(itemsdata)
    }
  }

  /* print modal handler */
  const [showPrintModal, setShowPrintModal] = useState(false)
  const handleShowPrintModal = () => setShowPrintModal(true)
  const handleClosePrintModal = () => setShowPrintModal(false)

  async function handlePrintPO() {
    setIsClicked(true)
    Print()
    // handleClosePrintModal()
    // const response = await changeStatusPurchaseOrder(poID, "print");

    // if (response.response) {
    //   const response1 = await changeStatusPurchaseOrder(poID, "sent");
    //   if (response.response) {
    //     toast.loading("Printing Purchase Request", {
    //       style: toastStyle(),
    //     });
    //     handleClosePrintModal();
    //     setTimeout(() => {
    //       toast.dismiss();
    //       Print();
    //     }, 1000);
    //   } else {
    //     TokenExpiry(response1);
    //   }
    // } else {
    //   TokenExpiry(response);

    //   toast.error("Error Printing Purchase Request", {
    //     style: toastStyle(),
    //   });
    // }
  }

  //   async function handleSendToSupplier() {
  //     setIsClicked(true);
  //     if (printPO.supplier_email || printPO.vendor_email) {
  //       const response = await emailPurchaseOrder(poID);

  //       if (response.response) {
  //         toast.success(response.response.response, {
  //           style: toastStyle(),
  //         });
  //         setTimeout(() => {
  //           navigate("/purchaseorders", {
  //             params: {
  //               state: "sent",
  //             },
  //           });
  //         }, 1000);
  //       } else {
  //         toast.error("Error Sending Purchase", {
  //           style: toastStyle(),
  //         });
  //         setTimeout(() => {
  //           setIsClicked(false);
  //           handleCloseSendModal()
  //         }, 1000);
  //       }
  //     } else {
  //       toast.error("Error sending email. Supplier/vendor has no email!", {
  //         style: toastStyle(),
  //       });
  //       setTimeout(() => {
  //         setIsClicked(false);
  //         handleCloseSendModal()
  //       }, 1000);
  //     }
  //   }

  function renderTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th>quantity</th>
            <th>unit</th>
            <th>complete item description</th>
            <th className="text-end">selling price</th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th>remarks</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            return (
              <tr key={item.id}>
                <td>{parseFloat(item.quantity)}</td>
                <td>{item.uom}</td>
                <td>{item.description}</td>
                <td className="text-end">{parseFloat(item.selling_price)}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{item.remark}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
    // setTimeout(() => {
    //     refreshPage();
    // }, 10);
  }

  useEffect(() => {
    fetchPurchaseRequest()
  }, [])

  return (
    <div className="page">
      <div className="print-page page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"PURCHASES"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <div className="px-3 py-2" id="printablediv">
          <div className="text-end print-header">
            <span>PURCHASE REQUEST NO. {printPO.id}</span>
          </div>
          <div className="print-top d-flex justify-content-center py-1">
            <img src={cleanLogo} className="print-logo" alt="" />
          </div>
          <div className="print-top">
            <h5 className="print-shop-header d-flex justify-content-center">
              LEYTE PAPERWORLD
            </h5>
            <h5 className="print-shop-header d-flex justify-content-center">
              168 M.H. Del Pilar, Tacloban City, Leyte
            </h5>
            <h5 className="print-shop-header d-flex justify-content-center">
              (053) 325-3888 (053) 325-7088
            </h5>
            <h5 className="print-shop-header d-flex justify-content-center">
              penpaperworld@yahoo.com
            </h5>
            <h5 className="print-shop-header d-flex justify-content-center">
              PURCHASE REQUEST
            </h5>
          </div>

          {/* content */}
          <div className="mt-5">
            <Row>
              <Col xs={7}>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-data">
                    Department Nam
                  </Col>
                  <Col xs={6} className="print-data">
                    {printPO.department_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-data">
                    Branch:
                  </Col>
                  <Col xs={6} className="print-data">
                    {printPO.branch}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-data">
                    OIC/Head:
                  </Col>
                  <Col xs={6} className="print-data">
                    {printPO.oic}
                  </Col>
                </div>
              </Col>

              <Col xs={5}>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-data">
                    Requested By:
                  </Col>
                  <Col xs={6} className="print-data align-items-start">
                    {printPO.requested_by_name}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-data">
                    Request Date:
                  </Col>
                  <Col xs={6} className="print-data">
                    {dateFormat(printPO.request_date)}
                  </Col>
                </div>
                <div className="d-flex my-2 align-items-center">
                  <Col xs={4} className="print-data">
                    Required Date:
                  </Col>
                  <Col xs={6} className="print-data">
                    {dateFormat(printPO.required_date)}
                  </Col>
                </div>
              </Col>
            </Row>
            <div className="d-flex mt-5 mb-2 justify-content-evenly">
              {/* table */}
              <div className="print-table mt-3 mx-2">{renderTable()}</div>
            </div>
            <div className="">
              <Row className="mt-4">
                <span className="print-footer">{printPO.remarks}</span>
              </Row>
              <Row className="mt-2 mb-5">
                <Col xs={6} className="print-sig justify-content-center d-flex">
                  <Row className="print-sig justify-content-center gotham">
                    <img
                      src={printPO.added_by_name_signature}
                      className="print-logo"
                      alt=""
                    />
                    {printPO.added_by_name}
                    <div className="margin-underline"></div>
                    Prepared by
                  </Row>
                </Col>
                <Col xs={6} className="print-sig justify-content-center d-flex">
                  <Row className="print-sig justify-content-center gotham">
                    <img
                      src={printPO.approved_by_name_signature}
                      className="print-logo"
                      alt=""
                    />
                    {printPO.approved_by_name}
                    <div className="margin-underline"></div>
                    <p className="text-center">Approved by</p>
                  </Row>
                </Col>
              </Row>
            </div>
            {/* <div className="print-signatures mt-5">
              <div className="d-flex align-items-center justify-content-end flex-column">
                <img src={signature} className="print-logo" alt=""/>
                <span className="text-center text-uppercase nc-modal-custom-text">
                  {printPO.added_by_name}
                </span>
              </div>
              <div className="d-flex align-items-center justify-content-center flex-column">
                <img src={printPO.approved_by_name_signature} className="print-logo" alt=""/>
                <span className="text-center text-uppercase nc-modal-custom-text">
                  {printPO.approved_by_name}
                </span>
              </div>
            </div>
            <div className="print-signatories pb-4 mb-4">
              <span>Prepared by</span>
              <span>Approved by</span>
            </div> */}
          </div>
        </div>

        {/* footer */}
        <div className="d-flex justify-content-end my-4 pb-5 ">
          <button
            className="button-secondary me-3"
            // style={{ width: "100%" }}
            onClick={() => navigate("/purchaserequest")}
          >
            Close
          </button>
          {/* <button
            className="button-secondary me-3"
            // style={{ width: "100%" }}
            onClick={handleShowSendModal}
          >
            Send to Supplier
          </button> */}
          <button
            className="button-primary"
            // style={{ width: "100%" }}
            onClick={handleShowPrintModal}
          >
            Print
          </button>
        </div>
      </div>
      {/* modals */}
      <POModal
        show={showPrintModal}
        hide={handleClosePrintModal}
        type="print"
        handler={() => {
          Print()
        }}
        isClicked={isClicked}
      />

      {/* <POModal
        show={showSendModal}
        hide={handleCloseSendModal}
        type="send"
        handler={handleSendToSupplier}
        isClicked={isClicked}
      /> */}
      <Footer />
    </div>
  )
}
